import {
  SEND_MESSAGE,
  SEND_MESSAGE_FULFILLED,
  SEND_MESSAGE_REJECTED,
  DELETE_CONVERSATION,
} from "./actionTypes";

const initialState = {
  isLoading: {},
  conversationMessages: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SEND_MESSAGE: // agregar mensaje del usuario
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.payload.conversationId]: true,
        },
        conversationMessages: {
          ...state.conversationMessages,
          [action.payload.conversationId]: [...(state.conversationMessages?.[action.payload.conversationId] || []), action.payload.message],
        }
      };
    case SEND_MESSAGE_FULFILLED: // agregar respuesta del bot
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.payload.conversationId]: false,
        },
        conversationMessages: {
          ...state.conversationMessages,
          [action.payload.conversationId]: [...(state.conversationMessages?.[action.payload.conversationId] || []), action.payload.message],
        }
      };
    case SEND_MESSAGE_REJECTED:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.payload.conversationId]: false,
        },
        conversationMessages: {
          ...state.conversationMessages,
          [action.payload.conversationId]: [...(state.conversationMessages?.[action.payload.conversationId] || []), action.payload.message],
        }
      };

    case DELETE_CONVERSATION:
      return {
        ...state,
        conversationMessages: {
          ...state.conversationMessages,
          [action.payload.conversationId]: [action.payload.message],
        }
      };
    default:
      return state;
  }
}
